export default __webpack_public_path__ + "static/media/1024px-Facebook_Logo_(2019).4a455df5.png";